<template>
  <a-layout class="blank-layout">
    <slot></slot>
  </a-layout>
</template>
